import * as React from 'react'
import * as ReactDOM from 'react-dom'

import App from './ui/app'

const app = <App />

ReactDOM.render(app, document.getElementById('app')!)



// WEBPACK FOOTER //
// ./src/index.tsx